import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'app-publictoesp',
  templateUrl: './publictoesp.page.html',
  styleUrls: ['./publictoesp.page.scss'],
})
export class PublictoespPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    if (this.api.publicToEsp.length == 0) {
      this.api.getPublicToEsp();
    }
  }

}
